import { StatesService_collCalcStateServiceGetQueryCcStates } from '@festina/collcalc-general-types/collcalc/hooks/StatesService_collCalcStateServiceGetQueryCcStates'

export const useFetchCollCalcStates =
  StatesService_collCalcStateServiceGetQueryCcStates.useSuspenseQuery
